import React from "react";
import styles from "./TableWrapper.module.scss";

export interface ITableWrapperProps {
  className?: string;
  children?: React.ReactNode;
}

export const TableWrapper: React.FC<ITableWrapperProps> = ({
  className,
  children,
}) => {
  return (
    <table className={`${styles.tableWrapper} ${className}`}>{children}</table>
  );
};
